module.exports = __webpack_public_path__ + "img/file-up-btn.ef174e45.svg";